import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { BlogPost } from "@tih/shared";
import { adminDeleteBlogPost, adminFetchBlog } from "../../api/client";

export function AdminBlogPage() {
  const [rows, setRows] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setLoading(true);
    setError(null);
    try {
      setRows(await adminFetchBlog({ generalOnly: true }));
    } catch (e) {
      setError(String((e as Error).message ?? e));
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { void load(); }, []);

  async function remove(id: number, title: string) {
    if (!confirm(`Delete "${title}"? This cannot be undone.`)) return;
    await adminDeleteBlogPost(id);
    await load();
  }

  return (
    <div className="admin-page">
      <header className="admin-page-header admin-page-header-row">
        <div>
          <h1>Blog posts</h1>
          <p>{rows.length} general ministry posts (event recaps live under each event hub)</p>
        </div>
        <Link to="/admin/blog/new" className="btn btn-primary">New post</Link>
      </header>
      {error && <div className="form-error">{error}</div>}
      {loading ? (
        <div style={{ opacity: 0.5 }}>Loading…</div>
      ) : rows.length === 0 ? (
        <div style={{ opacity: 0.6 }}>No posts yet.</div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Slug</th>
                <th>Status</th>
                <th>Updated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.id}>
                  <td>{p.title}</td>
                  <td><code>{p.slug}</code></td>
                  <td>
                    <span className={`status-pill status-${p.status.toLowerCase()}`}>{p.status}</span>
                  </td>
                  <td>{new Date(p.updatedAt).toLocaleString()}</td>
                  <td className="admin-row-actions">
                    <Link to={`/admin/blog/${p.id}`} className="btn btn-ghost">Edit</Link>
                    {p.status === "PUBLISHED" && (
                      <Link to={`/blog/${p.slug}`} className="btn btn-ghost">View</Link>
                    )}
                    <button type="button" className="btn btn-danger" onClick={() => remove(p.id, p.title)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
